/*eslint-disable*/
import * as types from './../mutation-types'

const state = {
    homework: null,
    homeworkCopy: null,
    game: null,
    gamesParameters: null,
    course: null,
    lessonConductingTemplate: null,
    previousNumbers: {
        first: null,
        second: null
    },
    correctAnswers: {
        first: null,
        second: null
    },
    puzzleGamesParams: [],
};


const mutations = {
    [types.SET_HOMEWORK](state, homework) {
        state.homework = homework;
    },
    [types.SET_HOMEWORK_COPY](state, homeworkCopy) {
        state.homeworkCopy = homeworkCopy;
    },
    [types.SET_GAMES_PARAMETERS](state, parameters) {
        state.gamesParameters = parameters;
    },
    [types.SET_COURSE](state, course) {
        state.course = course;
    },
    [types.SET_LESSON_CONDUCTING_TEMPLATE](state, template) {
        state.lessonConductingTemplate = template;
    },
    [types.SET_GAME](state, game) {
        state.game = game;
    },
    [types.SET_PREVIOUS_NUMBERS](state, {position, numbers}) {
        state.previousNumbers[position] = numbers;
    },
    [types.SET_FIRST_CORRECT_ANSWER](state, answer) {
        state.correctAnswers.first = answer;
    },
    [types.SET_SECOND_CORRECT_ANSWER](state, answer) {
        state.correctAnswers.second = answer;
    },
    [types.SET_PARAMS_ARRAY](state, paramsArray) {
        state.paramsArray = paramsArray;
    },
    [types.SET_PUZZLE_GAMES_PARAMS_ARRAY](state, puzzleGamesParams) {
        state.puzzleGamesParams = puzzleGamesParams;
    },
};

export default {
    state,
    mutations
}
